import React, { Fragment } from 'react';
import intl from 'react-intl-universal';
import { withRouter } from 'react-router-dom';
import IdleTimer from 'react-idle-timer';
import { INIT_COUNT, IDLE_TIMEOUT, LOGOUT_URL } from 'src/constants/constants.js';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import { connect } from 'react-redux';

import { checkStatusPending } from 'src/ui/features/Messaging/state/messagingActions';
import DOMPurify from 'dompurify';

class LayoutContainer extends React.Component {
  constructor(props) {
    super(props);

    this.idleTimer = null;
    this.state = {
      expiryDialog: {
        open: false,
      },
      count: INIT_COUNT,
      timeout: IDLE_TIMEOUT,
      openDialog: false,
      counterStart: false,
      counterEnd: true,
    };
    this.secondsRemaining = 0;
    this.intervalHandle = 0;

    this._onActive = this._onActive.bind(this);
    this._onIdle = this._onIdle.bind(this);
    this._onAction = this._onAction.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.counterStart && !this.state.counterEnd && this.state.timeout / 1000 !== this.state.count) {
      //){
      this.tick();
    }
  }

  tick = () => {
    if (this.state.count <= 0) {
      this.clearIntervalHandle();
    } else {
      this.intervalHandle = setTimeout(() => {
        this.setState(prevState => ({
          count: --prevState.count,
          counterStart: true,
          counterEnd: false,
        }));
      }, 1000);
    }
  };
  clearIntervalHandle = () => {
    clearInterval(this.intervalHandle);
    this.setState({ counterStart: false, counterEnd: true });
    window.location.href = DOMPurify.sanitize(LOGOUT_URL + '&mode=3');
  };
  _onIdle = e => {
    this.idleTimer.pause();
    this.toggleModal();
    this.startCountdown();
  };
  startCountdown = () => {
    this.tick();
  };
  toggleModal = () => {
    /* */
    this.setState({
      expiryDialog: {
        open: !this.state.expiryDialog.open,
      },
      openDialog: false,
    });
  };
  _onCancel = () => {
    /* */
    this.toggleModal();
    clearInterval(this.intervalHandle);
    this.idleTimer.reset();
    this.setState({
      count: INIT_COUNT,
      openDialog: !this.state.openDialog,
    });
  };
  _onActive(e) {
    //console.log('user is active', e)
    //console.log('time remaining', this.idleTimer.getRemainingTime())
  }
  _onAction(e) {
    //console.log('user did something', e)
  }
  _onConfirm = () => {
    /* */
    this.toggleModal();
    clearInterval(this.intervalHandle);
    this.idleTimer.reset();
    this.setState({
      count: INIT_COUNT,
      counterStart: false,
      counterEnd: true,
    });
  };

  toggleModalLogout = () => {
    this.setState({
      openDialog: !this.state.openDialog,
    });
  };

  onConfirmIML = () => {
    this.toggleModalLogout();
    // clearInterval(this.intervalHandle);
    window.location.href = DOMPurify.sanitize(LOGOUT_URL + '&mode=1');
    //TODO: should probably call signout explicitly
    sessionStorage.setItem('userInfo', {});
  };

  onConfirmEYMP = () => {
    this.toggleModalLogout();
    // clearInterval(this.intervalHandle);
    window.location.href = DOMPurify.sanitize(LOGOUT_URL + '&mode=2');
    //TODO: should probably call signout explicitly
    sessionStorage.setItem('userInfo', {});
  };
  render() {
    return (
      <Fragment>
        <IdleTimer
          ref={ref => {
            this.idleTimer = ref;
          }}
          timeout={this.state.timeout}
          onIdle={this._onIdle}
          onActive={this._onActive}
          onAction={this._onAction}
          startOnMount={true}
        />
        {this.props.children}
        <ConfirmDialog
          open={this.state.expiryDialog.open}
          title={intl.get('global.expiryMessage.title')}
          cancelText={intl.get('global.expiryMessage.cancelText')}
          confirmText={intl.get('global.expiryMessage.confirmText')}
          onCancel={this._onCancel}
          onConfirm={this._onConfirm}>
          <span>{intl.get('global.expiryMessage.text', { val: `${this.state.count}` })}</span>
        </ConfirmDialog>
        {!this.state.expiryDialog.open && this.state.openDialog && (
          <ConfirmDialog
            open
            title={intl.get('globalMenu.logoutConfirmation')}
            cancelText={intl.get('globalMenu.imlLogout')}
            confirmText={intl.get('globalMenu.eympLogout')}
            onCancel={this.onConfirmIML}
            onConfirm={this.onConfirmEYMP}
            toggleDrawer={this.toggleModalLogout}>
            <span>{intl.get('globalMenu.logoutText')}</span>
          </ConfirmDialog>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  userInfo: state.login.userInfo,
});

const mapDispatchToProps = {
  checkStatusPending,
};

const LayoutContainerWithRouter = withRouter(LayoutContainer);

export default connect(mapStateToProps, mapDispatchToProps)(LayoutContainerWithRouter);
